import React from 'react'
import { css } from '@emotion/core'
import { NoticeLoading } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

const center = css`
  position: fixed;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
`

export default function LoadingSpinner() {
  const { t } = useTranslation()
  return (
    <div data-testid="spinner" css={center}>
      <NoticeLoading size="lg" aria-label={t('common-ui:loading.ellipsis.label', 'Loading...')} />
    </div>
  )
}
